import React from 'react';
import ReactDOM from 'react-dom';
// Ported from projectpage/addToChallenge.js.
import { AddToChallengeWidget } from '../common/addToChallengeWidget.js';

// isEligibleForFunding is set in proposal.jsp
// proposalId is set in ProposalControllerService.generatePageJSVariables
// getFavList is defined in general/favorites.js
// isNonBlankCookie is defined in cookies.js
/* global isEligibleForFunding, proposalId, getFavList, isNonBlankCookie */

function setAddToProjectFavoritesWidth(fullWidth) {
    $('#resizeSaveForLater').remove();
    const fWidth = (fullWidth) ? 'width: 100% ! important' : 'width: auto';
    $('head').append('<style id="resizeSaveForLater" type="text/css">.supporting-detail.secondary-actions-wrapper .js-save {' + fWidth + '}</style>');
}

function setupChallengeLinks() {
    if (!isEligibleForFunding) {
        if (document.getElementById('add-to-campaign-holder')) {
            ReactDOM.unmountComponentAtNode(document.getElementById('add-to-campaign-holder'));
        }
        return;
    }

    // favLists can be slow to update, so check that the user is cookied first
    if (!isNonBlankCookie('userId')) {
        ReactDOM.unmountComponentAtNode(document.getElementById('add-to-campaign-holder'));
        try {
            setAddToProjectFavoritesWidth(true);
        } catch(e) {
            //
        }
        return;
    }
    // retrieve giving page list from localStorage
    $.when(getFavList('myGPs')).then(function (favList) {
        // using React.createElement to avoid compiling as jsx
        ReactDOM.render(
            React.createElement(AddToChallengeWidget, { project: { id: proposalId }, donorGivingPages: favList }),
            document.getElementById('add-to-campaign-holder'),
        );

        $('#add-to-campaign-holder').css('display', 'inline-block');
        $('.add-to-campaign').addClass('button-secondary').addClass('small');

        try {
            setAddToProjectFavoritesWidth(!favList || favList.length === 0);
        } catch (e) {
            //
        }
    });
}

export const main = () => {
    $(document).ready(function () {
        setupChallengeLinks();
    });
    $(window).on('userCookiesReset', function () {
        setupChallengeLinks();
    });
    $(document).on('updateFavoritesCookie', function () {
        setupChallengeLinks();
    });
};
